import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { BloodPressureData } from './API'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing(2),
        opacity: '95%'
    },
}));

const BloodPressureDataChart = ({ bloodPressureData }: { bloodPressureData: BloodPressureData[] }) => {
    const classes = useStyles();
    // console.log(bloodPressureData)
    const latestData = bloodPressureData.map((data) => ({
        ...data,
        date: new Date(Date.parse(data.date + 'Z')).toLocaleString('default', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }), // Convert to local time string
    }));
    latestData.reverse()

    return (
        <div>
            <Paper className={classes.paper}>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart
                        data={latestData}
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="diastolic" stroke="#4682B4" activeDot={{ r: 8 }} name="Diastolic Pressure" />
                        <Line type="monotone" dataKey="systolic" stroke="#FF4500" activeDot={{ r: 8 }} name="Systolic Pressure" />
                        <Line type="monotone" dataKey="heart_rate" stroke="#32CD32" activeDot={{ r: 8 }} name="Heart Rate" />
                    </LineChart>
                </ResponsiveContainer>
            </Paper>
        </div>
    );
};

export default BloodPressureDataChart;
